import ContactPage from "components/ContactContent/contact";
import withTranslation from "next-translate/withTranslation";
import { withRouter } from "next/router";
import { Component } from "react";

import Footer from "SanityComponents/Footer/Footer";

class Contact extends Component {
  componentDidMount() {

  }

  render() {
    const { t } = this.props.i18n;
    return (
      <>
        <ContactPage />
        <div>
          <Footer isContact={true} />
        </div>
      </>
    );
  }
}

export default withRouter(withTranslation(Contact, "common"));
